import React, { useRef, useState, useEffect } from "react";
import SoundSettings from "../components/SoundSettings";
import { AutoCenter, Button, Dialog, Divider, List, Modal, NavBar, Space, SwipeAction, Toast } from "antd-mobile";
import { AddOutline, MinusOutline, CloseOutline, CheckOutline, FingerdownOutline, InformationCircleOutline, DownOutline } from 'antd-mobile-icons'
import logo from "../media/logo2.png"
import Scanner from "../components/Scanner";

import scanned from "../media/scanned.wav";
import short from "../media/short.wav";
import even from "../media/agree.wav";
import over from "../media/over.wav";
import not_found from "../media/notfound.wav";
import old from "../media/oldstock.wav";
import ListItem from "../components/ListItem";
import { pubCall, pubSub } from "../utils/PubSub";
import { playRecSound } from "../utils/Sounds";
import { drawError, isAlphaNum } from "../utils/utils";
import Scroll from "../components/Scroll";
import Ping from "../components/Ping";
import Settings from "../components/Settings";
import Bar from "../components/Bar";
import Keyboard from "../components/Keyboard";

export default function Reconciliation(props) {

    const { globals = {} } = props;
    const ref = useRef();
    const [count, setCount] = useState(1)
    const [results, setResults] = useState([])
    const [loading, setLoading] = useState(false);
    const [filter, setFilter] = useState(false);
    const [oh, setOh] = useState(false);
    const [visible, setVisible] = useState(false);
    const [lastCall, setLastCall] = useState("");
    const [listening, setListening] = useState(true);
    const [selected, setSelected] = useState(false);
    const [scrolling, setScrolling] = useState(false);
    const [scrollTrigger, setScrollTrigger] = useState(false);
    const [scrollTopTrigger, setScrollTopTrigger] = useState(false);
    const [show, setShow] = useState(false);

    const [keyboard, setKeyboard] = useState(false);
    const [input, setInput] = useState(false);

    const [searching, setSearching] = useState(false);
    // Submit
    const submit = (_ean, _count, _force = false, _filter) => {



        let _args = {
            primary_code: _ean.trim(),
            condition_code: " ",
            count: parseInt(_count),
            oh_filter: false,
            work_station_filter: true,
            limit: 20,
        }



        // Add ignore if forced
        if (_force) { _args.ignore_new_warning = true }

        // Instanciate sounds objects (Need to do this here becasue audio is tied to UI events)
        const _scanned = new Audio(scanned);
        const _short = new Audio(short);
        const _over = new Audio(over);
        const _even = new Audio(even);
        const _not_found = new Audio(not_found);
        const _old = new Audio(old);

        // Clear results (maybe can get rid of this by creating proper ids?)
        setResults([]);

        pubCall("reconciliation.submitAdditive", _args, (_status, _result) => {
            if (_status) {
                const lastItem = _result[_result.length - 1];
                playRecSound(lastItem.counted, lastItem.onhand, lastItem?.stock_data?.receive_date, true, { scanned: _scanned, short: _short, over: _over, even: _even, error: _not_found, months: _old }, !_force);
                setResults(_result);
                setKeyboard("");
            } else {
                setListening(false)
                if (_result.error === "com.bmo.does_not_exist") {
                    playRecSound(0, 0, false, false, { scanned: _scanned, short: _short, over: _over, even: _even, error: _not_found, months: _old });
                    //setVisible(false);
                    Dialog.confirm({
                        style: { zIndex: "1002" },
                        bodyStyle: { zIndex: "1002" },
                        maskClassName: "flashing-background",
                        content: <><AutoCenter><strong>{_ean}</strong></AutoCenter><AutoCenter>Does not exist.</AutoCenter></>,
                        confirmText: "Add",
                        cancelText: "Dismiss",
                        onCancel: () => {
                            setListening(true);
                            getInitial(_filter);
                        },
                        onConfirm: () => {
                            setListening(true)
                            submit(_ean, _count, true, _filter);
                        },
                    })
                } else {
                    _not_found.play();
                    drawError(_result);
                }
            }
            setCount("0")
        })
    }

    // Keyboard Event handle
    useEffect(() => {

        if (!globals.connect) {
            return;
        }

        let c = "";
        const handleKeyDown = (e) => {

            if (e.target.id === "manual" || e.target.id === "qty") {
                return;
            }

            // Not listening key event....
            if (!listening) {
                // Someone scanned while not listing
                if (e.key === "Enter") {
                    let _not_found = new Audio(not_found);
                    _not_found.play();
                }
                return;
            }

            e.preventDefault();
            e.stopPropagation();

            if (e.key && (isAlphaNum(e.key) || e.key == ' ') && e.key.length === 1) {
                c = c + e.key;
            }

            if (e.key === "Enter") {
                e.preventDefault();
                e.stopPropagation();
                let _amount = parseInt(count);
                if (Number.isNaN(_amount)) {
                    _amount = 1;
                }
                let _code = (c.substring(0, 1) === "~") ? c.substring(1, c.length) : c;

                if (searching) {
                    search(_code);
                } else {
                    submit(_code, (_amount) ? _amount : 1, false, true);
                }

                c = "";
                return;
            }
        };

        // Add event listener for keydown event
        window.addEventListener('keydown', handleKeyDown);

        // Cleanup function to remove event listener when component unmounts
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [listening, count, filter, globals.connect, searching]);


    // Fetch first set 
    const getInitial = (_filter = filter, animate = false) => {


        let _filters = {
            oh_filter: (searching) ? oh : false,
            work_station_filter: (searching) ? _filter : true,
            limit: 20,
        }
        setLoading(true)
        pubCall("reconciliation.getLast", _filters, (_status, _result) => {
            if (_status) {


                if (animate && _result?.length > 0) {
                    _result[_result.length - 1].animate = true;
                    setResults(_result);
                } else {
                    setResults(_result);
                }

            } else {
                console.error(_result);
            }
            setTimeout(() => { setLoading(false) }, 300)
        })
    }


    const handleSearch = (_result, _clear = false) => {
        if (_result.rows_next?.length < 5) {
            setSearching(_result.rows_next[0].reconciliation_id);
            setResults(_result.rows_previous.concat(_result.rows_next));
            setScrollTrigger(!scrollTrigger)
            setScrollTopTrigger(true);
            setTimeout(() => setScrollTrigger(!scrollTrigger), 1000);
        } else {
            setSearching(_result.rows_next[0].reconciliation_id);
            setScrollTopTrigger(true);
            setResults(_result.rows_next);
            setTimeout(() => setScrollTopTrigger(false), 1000);
        }

        if (_clear) {
            setFilter(false);
        }

        setOh(false)
    }

    const search = (_code) => {

        if (!_code) {
            return;
        }

        let _filters = {
            isbn: _code,
            work_station_filter: (searching) ? filter : true,
            limit: 20,
        }

        setLoading(true);
        pubCall("reconciliation.search", _filters, (_status, _result) => {
            if (_status) {
                handleSearch(_result)
            } else {

                if (filter) {
                    Modal.confirm({
                        title: "Not found",
                        confirmText: "Search all records",
                        cancelText: "Close",
                        onConfirm: () => {
                            pubCall("reconciliation.search", { ..._filters, work_station_filter: false }, (_s, _r) => {
                                handleSearch(_r, true)
                            })
                        },
                        onCancel: () => {

                        }
                    })
                } else {
                    Toast.show({ maskClassName: "warning", content: <div style={{ "textAlign": "center" }}><strong>{_code}</strong><div className="shim" />Not in reconciliation file</div> })
                }
            }
            setTimeout(() => { setLoading(false) }, 300)
        })
    }

    // Fetch Previous
    const getPrev = () => {

        return new Promise((resolve, reject) => {
            if (results.length === 0) {
                reject("No results available");
                return;
            }
            let _row = results[0];
            let _filters = {
                oh_filter: (searching) ? oh : false,
                work_station_filter: (searching) ? filter : true,
                date_created: _row.date_created,
                reconciliation_id: _row.reconciliation_id,
                limit: 20
            };
            if (lastCall === _row.reconciliation_id) {
                reject("No more previous");
                return;
            }
            setLastCall(_row.reconciliation_id)
            pubCall("reconciliation.getPrevious", _filters, (_status, _result) => {
                if (_status) {
                    let _update = [...results];
                    _update = _result.concat(_update);


                    let current;

                    if (ref?.current) {
                        current = ref.current.scrollTop;
                        setResults(_update);
                        setTimeout(() => {
                            ref.current.scrollTop = current;

                        }, 0)
                    } else {
                        setResults(_update);
                    }
                    if (_update) {
                        resolve(_update)
                    } else {
                        resolve();
                    }
                    return;
                } else {
                    console.error(_result);
                    reject();
                }
            });
        });
    };

    // Fetch next items


    const getNext = () => {

        if (scrolling) {
            return;
        };

        if (results.length <= 0) {
            return;
        }

        let _row = results[results.length - 1];
        let _filters = {
            oh_filter: (searching) ? oh : false,
            work_station_filter: (searching) ? filter : true,
            date_created: _row.date_created,
            reconciliation_id: _row.reconciliation_id,
            limit: 20
        };

        setLastCall(_row.reconciliation_id)
        pubCall("reconciliation.getNext", _filters, (_status, _result) => {
            if (_status) {
                let _update = [...results];
                _update = _update.concat(_result);
                setResults(_update);
            } else {

            }
        });

    };

    useEffect(getNext, [scrolling])


    const [record, setRecord] = useState({});

    // Listen for record updates..
    useEffect(() => {

        if (!record?.action) {
            return;
        }

        // Reload
        if (record?.action === "reload") {
            getInitial();
            Toast.show({ content: <div style={{ "textAlign": "center" }}>Bulk changes detected<div className="shim" />Reloading...</div> })
            setRecord({});
            return;
        }

        // Push new to the bottom of the list
        if (record?.action === "row_new") {

            // Don't add new records while 
            if (!searching || oh || filter) { return; }

            setResults([...results].concat([record?.data]));
            setRecord({});
            return;
        }

        // Find
        let _f = results.findIndex(item => (item.primary_code === record?.data?.primary_code && item.condition_code === record?.data?.condition_code))

        if (_f > -1) {
            // Delete
            if (record?.action === "row_delete") {
                let _drop = results.filter(item => item.reconciliation_id !== record?.data.reconciliation_id);
                setResults(_drop);
                setRecord({});
                return;
            }
            // Update
            if (record?.action === "row_update") {
                let _r = [...results];
                _r[_f] = { ...record.data };
                setResults(_r);
                setRecord({});
                return;
            }
        } else {
            if (record?.action === "row_update") {
                if (!searching || oh || filter) { return; }
                // not in my local list - add
                setResults([...results].concat([record?.data]));
                setRecord({});
                return;
            }

        }

    }, [record, searching, filter, oh])

    // Subscription to state
    useEffect(() => {
        pubSub("reconciliation", {}, (_e, _f = {}) => {
            setRecord(_f.message)
        })
    }, [record])

    // Inital load + on filter change
    useEffect(() => {
        if (!searching || searching === true) {
            setResults([])
            getInitial()
        }

    }, [filter, oh, searching]);

    // Move to the "top" of the list
    useEffect(() => {
        if (!ref.current) {
            return;
        }
        ref.current.scrollTop = 0;
    }, [visible]);


    useEffect(() => {
        Toast.show({ content: <div style={{ "textAlign": "center", "wordBreak": "keep-all" }}><big>{window.credentials.name}</big></div> })
    }, [])

    // Update local data without having to refetch (for increments)
    const updateRow = (_row) => {
        let _rows = [...results];
        let _ind = _rows.findIndex(item => item.reconciliation_id === _row.reconciliation_id);
        if (_ind > -1) {
            _rows[_ind].counted = _row.counted;
            setResults(_rows)
        }
    }

    // Remove item
    const remove = (_item) => {
        pubCall("reconciliation.delete", { reconciliation_id: _item.reconciliation_id }, (_status, _result) => {
            if (_status) {
                Toast.show({ content: <div style={{ "textAlign": "center", "wordBreak": "keep-all" }}>{_item.title}<div className="shim" />Removed successfully</div> })
                getInitial();
                setSelected("")
            } else {
                console.log(_result.error)
            }
        })
    }


    // Increment and Decrement 
    const increment = (_row, _amt, _reset_selected = false, _augment = true) => {


        let _count = parseInt(_row.counted) || 0;
        _count += _amt;

        if (!_augment) {
            _count = parseInt(_amt) || 0;
        }

        let _args = {
            primary_code: _row.primary_code,
            condition_code: _row.condition_code,
            count: _count,
        }
        pubCall("reconciliation.submit", _args, (_status, _result) => {
            if (_status) {
                updateRow(_result);
                if (_reset_selected) {
                    setSelected(false);
                }
            } else {
                Toast.show({ content: <div style={{ "textAlign": "center" }}><div className="shim" />There was an error.</div> })
            }
        })
    }

    // Swipe actions
    const rightActions = [
        { key: 'remove', text: <>&nbsp;&nbsp;&nbsp;&nbsp; <CloseOutline /> &nbsp;&nbsp;&nbsp;&nbsp;</>, color: '#a65959' },
    ]
    const leftActions = [
        { key: 'increment', text: <>&nbsp; <AddOutline /> &nbsp;</>, color: '#007ef5' },
        { key: 'decrement', text: <>&nbsp; <MinusOutline /> &nbsp;</>, color: '#007ef5' },
    ]

    const getHeight = () => {
        let _h = 217;
        if (keyboard) {
            _h = 540;
        }
        return window.innerHeight - _h;
    }


    const drawHeader = () => {
        return (
            <div>
                <br />
                <div className="shim" />
                <NavBar right={<div><Settings />&nbsp;</div>} style={{ "height": "20px" }} backArrow={false} left={<div style={{ "marginLeft": "-10px", "marginTop": "2px" }}><img alt={"Bookmanager Reconciliation"} height={20} src={logo} /></div>}>
                    <strong>Reconciliation</strong>
                    <div style={{ "marginTop": "-5px", "fontSize": "16px" }}><small><em><a> (#{globals.station}) {window.credentials.name}</a></em></small></div>
                </NavBar>
                <Divider style={{ "opacity": ".5", "marginBottom": "0px", "borderColor": "#161718" }} />
                <div style={{ "display": "flex", "paddingLeft": "15px", "paddingRight": "10px", "textAlign": "center", "opacity": "0.5" }}>
                    <div style={{ "width": "16%" }}>COUNT</div>
                    <div style={{ "width": "9%" }}>OH</div>
                    <div style={{ "width": "16%" }}>DIFF</div>
                    <div style={{ "width": "18%", "textAlign": "right" }}>PRICE</div>
                    <div style={{ "width": "2%" }}></div>
                    <div style={{ "width": "30%", "textAlign": "left" }}>CLASS</div>
                    <div style={{ "width": "auto", "textAlign": "right" }}>WS</div>
                </div>
            </div>
        )
    }

    const draw = () => {
        return (
            <div


                onClick={(e) => {

                    if (visible) {
                        e.preventDefault();
                        e.stopPropagation();
                        setVisible(false);
                    }



                }} className={(loading) ? "fade-in-loading" : "fade-out-loading"} style={{ "height": "200px", "filter": (selected?.reconciliation_id || show || keyboard) ? "brightness(.5)" : "none", "pointerEvents": (selected?.reconciliation_id || show || keyboard) ? "none" : "auto" }} >
                <Scroll ref={ref} scrollTopTrigger={scrollTopTrigger} scrollTrigger={scrollTrigger} height={getHeight()} scrolling={scrolling} setScrolling={setScrolling} fetchMoreData={(prev = false) => {

                    if (prev) {
                        return getNext();
                    } else {
                        return getPrev();
                    }
                }}>
                    {results.map((item, index) => {


                        return (

                            <ListItem
                                oh={oh}
                                search={search}
                                remove={remove}
                                increment={increment}
                                searching={searching}
                                leftActions={leftActions}
                                rightActions={rightActions}
                                selected={selected}
                                setSelected={setSelected}
                                canFade={(index === results.length - 1)}
                                item={item} />

                        )
                    })}
                    {/* <List.Item style={{ "height": "105px" }} arrow={false}>
                        <Scanner listening={listening} setListening={setListening} submit={submit} count={(count) ? count : "0"} setCount={setCount} visible={visible} setVisible={setVisible} />
                    </List.Item> */}
                </Scroll>
            </div>
        )
    }

    const updateCount = (_count) => {
        if (selected?.reconciliation_id) {
            setSelected({ ...selected, "counted": _count, "init": false })
            return;
        }
        setCount(_count);
    }

    const incrementSelected = (_inc = false) => {

        let _c = selected.counted;
        if (_c) {
            _c = parseInt(_c);
        } else {
            _c = 0;
        }

        if (_inc) {
            _c += 1;
        } else {
            _c -= 1;
        }

        setSelected({ ...selected, "counted": _c })
    }

    return (
        <>
           
            <div className="app" style={{ "height": `${window.innerHeight}px`, "overflow": "hidden" }} >
                <div className="top">
                    {drawHeader()}
                </div>
                <div className="body">
                    <div className="heightAni" style={{ "width": "100%", "height": getHeight() + "px", "overflow": "auto" }} >
                        {draw()}

                    </div>
                </div>
                <div className="bottom">
                    {(scrolling && <div style={{ "position": "absolute", "right": "25px", "marginTop": "-50px" }}><Button onClick={() => setScrollTrigger(!scrollTrigger)} style={{ "borderRadius": "0px" }} color="success"><DownOutline /></Button></div>)}


                    <Bar
                        keyboard={keyboard}
                        setKeyboard={setKeyboard}
                        getInitial={getInitial}
                        globals={globals}
                        increment={increment}
                        remove={remove}
                        submit={submit}
                        search={search}
                        searching={searching}
                        setSearching={setSearching}
                        selected={selected}
                        setSelected={setSelected}
                        filter={filter}
                        setFilter={setFilter}
                        oh={oh}
                        setOh={setOh}
                        count={(count === "") ? "" : parseInt(count)}
                        setCount={setCount}
                    />


                    {/* <div >
                        {(selected?.reconciliation_id && <div>

                            <div style={{ "position": "absolute", "width": "100%", "zIndex": "1" }}>
                                <div style={{ "marginTop": "8px", "marginRight": "20px", "textAlign": "right" }}>
                                    <Space>
                                        <Button onClick={() => setSelected(false)} style={{ "borderRadius": "0px", "backgroundColor": "#e70d3d" }}><big><big><CloseOutline /></big></big></Button>
                                        <Button onClick={() => increment({ ...selected }, 0, true)} color="success" style={{ "borderRadius": "0px", "borderColor": "#007EF5", "backgroundColor": "#007EF5" }}><big><big><CheckOutline /></big></big></Button>
                                    </Space>
                                </div>
                            </div>
                            <ListItem noswipe selected={selected} setSelected={setSelected} item={selected} /></div>)}
                        <Scanner show={show} setShow={setShow} search={search} selected={selected} setSelected={setSelected} setScrollTrigger={setScrollTrigger} scrollTrigger={scrollTrigger} scrolling={scrolling} listening={listening} setListening={setListening} submit={submit} count={(count) ? count : "0"} setCount={updateCount} visible={visible} setVisible={setVisible} />
                        {drawFilters()}
                    </div> */}
                </div>
            </div>
        </>
    )
}